import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiConst, KindOfRequest} from '../../../services/apiServices/api-const';
import {HttpService} from '../../../services/apiServices/http-service.service';
import {User} from '../../../model/user';
import {VirtualPrinterService} from '../../../services/apiServices/business/virtual-printer.service';
import {TranslateService} from '@ngx-translate/core';
import {PrinterPackage} from '../../../model/printer-file';
import {CommonService} from '../../../services/apiServices/business/common.service';

// @ts-ignore
@Component({
  selector: 'app-upload-virtual-printer',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UploadVirtualPrinterComponent implements OnInit {
  public virtualPrinterDataToUpload!: FormData;
  public virtualPrinterActiveTab!: number;
  public disallowForm!: boolean;
  public doUploadVirtualPrinter!: boolean;
  public virtualPrinterPackages: PrinterPackage[];
  public virtualPrinterPackagedFiles: any;
  public releaseRegExp!: RegExp;
  public releaseValue!: string;
  public uploadGenericVersionAvailable!: boolean;
  public genericVersion!: string;
  public versionList!: Array<any>;
  public uploadOK!: boolean;
  public uploadGenericMessages!: any;
  public uploadPackageMessages!: any;
  public genericPrinterDescription!: string;
  public specificPrinterDescription!: string;
  public packageName!: string;
  public description_required!: string;
  public inf_required!: string;
  public cmd_32_required!: string;
  public cmd_64_required!: string;
  public exe_32_required!: string;
  public exe_64_required!: string;
  public name_required!: string;
  public inf_rec_required!: string;
  public inf_prod_required!: string;
  public success!: string;
  public success_title!: string;
  public success_body!: string;

  @Input()
  public packagedVersion!: string;
  @Input()
  public user!: User;
  @Input()
  public displayUploadVirtualPrinterPanel!: boolean;
  @Input()
  public virtualPrinterList: any;
  @Output()
  public maskUploadVirtualPrinterPanel = new EventEmitter();
  @Output()
  public updateDownloadableList = new EventEmitter();

  constructor(  private http: HttpClient, private httpService: HttpService, private commonService: CommonService,
                private virtualPrinterService: VirtualPrinterService, private translate: TranslateService ) {
    this.initData();
  }

  public ngOnInit(): void {
    this.virtualPrinterDataToUpload = new FormData();
    this.virtualPrinterActiveTab = 0;
  }

  public initData() {
    this.getTraductions();

    this.genericPrinterDescription = '';
    this.specificPrinterDescription = '';
    this.packageName = '';
    this.uploadGenericVersionAvailable = false;
    this.disallowForm = true;
    this.doUploadVirtualPrinter = false;
    this.releaseRegExp = new RegExp('[0-9]{1,3}');
    this.releaseValue = '';
    this.genericVersion = '';
    this.uploadGenericVersionAvailable = false;
    this.virtualPrinterDataToUpload = new FormData();
    this.uploadOK = true;

    this.virtualPrinterPackages = [{
      ext: '.inf',
      files: [{
        name: 'NumenExpress.inf',
        error: 'inf_required',
        uploadable: false,
        valid: false,
        target: 'inf',
        desc: '.inf',
        accept: 'application/inf',
        message: ''
       }]
      }, {
      ext: '.cmd',
      files : [ {
        name: 'NumenExpress_x32.cmd',
        error: 'cmd_32_required',
        uploadable: false,
        valid: false,
        target: 'cmd_32',
        desc: 'script batch (cmd)',
        arch: '32 bits',
        accept: '.cmd',
        message: ''
      }, {
        name: 'NumenExpress_x64.cmd',
        error: 'cmd_64_required',
        uploadable: false,
        valid: false,
        target: 'cmd_64',
        desc: 'script batch (cmd)',
        arch: '64 bits',
        accept: '.cmd',
        message: ''
      }]
    }, {
      ext: '.exe',
      files: [{
        name: 'NumenExpress_x32.exe',
        error: 'exe_32_required',
        uploadable: false,
        valid: false,
        target: 'exe_32',
        desc: 'executable',
        arch: '32 bits',
        accept: 'application/octet-stream',
        message: ''
      }, {
        name: 'NumenExpress_x64.exe',
        error: 'exe_64_required',
        uploadable: false,
        valid: false,
        target: 'exe_64',
        desc: 'executable',
        arch: '64 bits',
        accept: 'application/octet-stream',
        message: ''
      }]
    }];
    this.virtualPrinterPackagedFiles = [{
      ext: '.inf',
      files: [{
        name: 'NumenExpress_rec.inf',
        error: 'inf_rec_required',
        uploadable: false,
        valid: false,
        target: 'recette',
        arch: 'Recette',
        accept: 'application/inf',
        message: 'Recette'
      }, {
        name: 'NumenExpress_prod.inf',
        ext: '.inf',
        error: 'inf_prod_required',
        uploadable: false,
        valid: false,
        target: 'production',
        arch: 'Production',
        accept: 'application/inf',
        message: 'Production'
      }]
    }];

    this.uploadGenericMessages = {
      errors: [{
        error: 'description_required',
        active: true,
        message: this.description_required
      }, {
        error: 'inf_required',
        active: true,
        message: this.inf_required
      }, {
        error: 'cmd_32_required',
        active: true,
        message: this.cmd_32_required
      }, {
        error: 'cmd_64_required',
        active: true,
        message: this.cmd_64_required
      }, {
        error: 'exe_32_required',
        active: true,
        message: this.exe_32_required
      }, {
        error: 'exe_64_required',
        active: true,
        message: this.exe_64_required
      }],
      success: {
        active: false,
        message: this.success
      }
    };

    this.uploadPackageMessages = {
      errors: [{
        error: 'name_required',
        active: true,
        message: this.name_required
      }, {
        error: 'description_required',
        active: true,
        message: this.description_required
      }, {
        error: 'inf_rec_required',
        active: true,
        message: this.inf_rec_required
      }, {
        error: 'inf_prod_required',
        active: true,
        message: this.inf_prod_required
      }],
      success: {
        active: false,
        message: this.success
      }
    };
  }

  public getTraductions(): void {
    this.translate.get('VIRTUAL_PRINTER.ERRORS.INF_REQUIRED' ).subscribe((res: string) => {
      this.inf_required = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.DESCRIPTION_REQUIRED').subscribe((res: string) => {
      this.description_required = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.CMD_32_REQUIRED').subscribe((res: string) => {
      this.cmd_32_required = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.CMD_64_REQUIRED' ).subscribe((res: string) => {
      this.cmd_64_required = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.EXE_32_REQUIRED' ).subscribe((res: string) => {
      this.exe_32_required = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.EXE_64_REQUIRED' ).subscribe((res: string) => {
      this.exe_64_required = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.NAME_REQUIRED' ).subscribe((res: string) => {
      this.name_required = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.INF_REC_REQUIRED' ).subscribe((res: string) => {
      this.inf_rec_required = res;
    });
    this.translate.get('VIRTUAL_PRINTER.ERRORS.INF_PROD_REQUIRED' ).subscribe((res: string) => {
      this.inf_prod_required = res;
    });
    this.translate.get('VIRTUAL_PRINTER.NO_PROBLEM' ).subscribe((res: string) => {
      this.success = res;
    });
    this.translate.get('VIRTUAL_PRINTER.SUCCESS.TITLE' ).subscribe((res: string) => {
      this.success_title = res;
    });
    this.translate.get('VIRTUAL_PRINTER.SUCCESS.BODY' ).subscribe((res: string) => {
      this.success_body = res;
    });
  }

  public handleInputErrors( event, error ): any {
    const isEmpty = !event.target.value,
      msgObject = this.getErrorObject();

    msgObject.errors.forEach(el => {
      if ( el.error === error && !isEmpty ) {
        el.active = false;
      } else if ( el.error === error && isEmpty ) {
        el.active = true;
      }
    });

    this.checkIfUploadFormIsValid( msgObject );
   }

  public handleFileErrors( msgObject, error, active ): void {
    msgObject.errors.forEach(el => {
      if ( el.error === error ) {
        el.active = active;
      }
    });

    this.checkIfUploadFormIsValid( msgObject );
  }

  public getVersionList(): any {
    this.versionList = this.virtualPrinterList.map(el => {
      return {label: el.release, value: el.release};
    });

    this.initPackageVersion();
  }

  public initPackageVersion(): void {
    this.packagedVersion = this.versionList[ 0 ].value;
  }

  public getSrcObject(): any {
    switch ( this.virtualPrinterActiveTab ) {
      case 0 : {
        return this.virtualPrinterPackages;
      }
      case 1 : {
        return this.virtualPrinterPackagedFiles;
      }
    }
  }

  public getErrorObject(): any {
      switch ( this.virtualPrinterActiveTab) {
        case 0 : {
          return this.uploadGenericMessages;
        }
        case 1 : {
          return this.uploadPackageMessages;
        }
      }
    }

  // @ts-ignore
    public getUploadUrl( ): { 'uploadType': string, 'url': KindOfRequest } {
    switch ( this.virtualPrinterActiveTab ) {
      case 0 :
        return { 'uploadType': 'generic',
          'url': ApiConst.uploadPrinterInstaller };
      case 1 :
        return { 'uploadType': 'package',
          'url': ApiConst.uploadPrinterPackage };
    }
  }

  public updateVirtualPrinterUploadFileList(event, target, error) {

    const files = event.target.files,
      src = this.getSrcObject(),
      msgObject = this.getErrorObject(),
      ext = this.getFileExtension( src, target );

    const canonicalName = this.getObjectName( target );
    this.setFileIsUploadable( target, src );

    for (let i = 0; i < files.length; i++) {
      const file = files[ i ];

      if (this.checkFileType( ext, file.name)) {
        if ( target === 'inf' ) {
         this.handleINFFile( file, src, target, canonicalName );
        } else {
          this.setFileName( src, target, file.name );
          this.virtualPrinterDataToUpload.append( 'file', file, canonicalName );
        }

        this.handleFileErrors( msgObject, error, false );
      } else {

        if ( ext === '.inf' ) {
          this.uploadGenericVersionAvailable = false;
        }

        this.setErrorMessage( src, target, ext );
        this.handleFileErrors( msgObject, error, true );
      }
    }

    this.checkIfUploadFormIsValid( msgObject );
  }

  public handleINFFile( file, src, target, canonicalName ): void {
    const fileReader = new FileReader(),
      r = new RegExp( '^PRODUCT_VERSION=(.*)', 'm' );

    let fileContent = '';

    const that = this;

    fileReader.onload = function ( evt: any ) {
      let matches;

      fileContent = evt.target.result;

      matches = fileContent.match( r );

      if ( matches ) {
        if ( matches[ 1 ].split( '.' ).length > 0 ) {
          let major,
            minor,
            patch;

          major = that.removeZero( matches[ 1 ].slice( 0, 2 ) );
          minor = that.removeZero( matches[ 1 ].slice( 2, 4 ) );
          patch = that.removeZero( matches[ 1 ].slice( 4, 6 ) );

          that.genericVersion = major + '.' + minor + '.' + patch;
        } else {
          that.genericVersion = matches[1];
        }
        that.uploadGenericVersionAvailable = true;
        that.setFileName(src, target, file.name);
        that.virtualPrinterDataToUpload.append('file', file, canonicalName);
      } else {
        that.genericVersion = null;
        that.uploadGenericVersionAvailable = false;
        that.setFileName( src, target, '' );
      }
    };

    fileReader.readAsText( file );
  }

  public removeZero ( str: string ): string {
    if ( str.charAt( 0 ) === '0' ) {
      return str[ 1 ];
    } else {
      return str;
    }
  }

  public setFileIsUploadable( target: string, src: Array<any> ): void {
    for ( const files of src ) {
      for ( const file of files.files ) {
        if (file.target === target) {
          file.uploadable = true;
        }
      }
    }
  }

  public getObjectName( target: string ): string {
    for ( const o of this.virtualPrinterPackages ) {
      for ( const file of o.files ) {
        if ( file.target === target ) {
          return file.name;
        }
      }
    }
    return '';
  }

  private checkIfUploadFormIsValid( msgObject: any ): void {

    const hasErrors =  msgObject.errors.some(el => {
      return el.error !== 'http_error' && el.active === true;
    }),
      hasHttpError = msgObject.errors.some( el => {
        return el.error === 'http_error';
      });

    if ( hasErrors ) {
      msgObject.success.active = false;
      this.disallowForm = true;
    } else {
      msgObject.success.active = true;
      this.disallowForm = false;
    }

    if ( hasHttpError && !hasErrors ) {
      msgObject.success.active = false;
      this.disallowForm = false;
    }
  }

  private getFileExtension( src: any, target: string ): string {

    for ( const o of src ) {
      for (const file of o.files) {
        if (file.target === target) {
          return o.ext;
        }
      }
    }
    return '';
  }

  private checkFileType(ext: string, fileName: string): boolean {

    const r = new RegExp (ext + '$' );
    return r.test(fileName);
  }

  public addFiles(event, target) {
    document.getElementById('virtualPrinterUpload_' + target).click();
  }

  private setFileName( src: any , target: string, fileName: string ): void {

    src.forEach( files => {
      files.files.forEach( file => {
        if (file.target === target) {
          file.valid = true;
          file.message = fileName;
        }
      });
    });
  }

  private setErrorMessage ( src: any, target: string, ext: string ): void {
    for ( const o of src ) {
      for ( const file of o.files ) {
        if ( file.target === target) {
          file.valid = false;
        }
      }
    }
  }

  public switchTabs( event ): void {
    this.virtualPrinterActiveTab = event.index;

    this.initData( );
  }

  public updatePackageVersion( event ): any {
    this.packagedVersion = event.value;
  }

  public uploadVirtualPrinter( event ): void {
    const that = this,
      { url, uploadType } = this.getUploadUrl( ),
      d = new Date(),
      month = d.getMonth() + 1,
      date = d.getFullYear() + '-' + month + '-' + d.getDay(),
      msgObject = this.getErrorObject();

      let data;

      if ( month < 10 ) {
        String( month ).padStart( 2, '0' );
      }

    switch (uploadType ) {
      case 'generic':
        data = {
          release: this.genericVersion,
          releaseNotes: this.genericPrinterDescription,
          date
        };
        this.virtualPrinterDataToUpload.set( 'release', JSON.stringify( data ) );
        break;
      case 'package':
        data = {
          name: this.packageName,
          release: this.packagedVersion,
          description: this.specificPrinterDescription
        };
        this.virtualPrinterDataToUpload.set( 'customerPackage', JSON.stringify( data ) );
        break;
    }

    const altData = {
      msgObject,
      uploadType
    };

    this.virtualPrinterService.uploadVirtualPrinter( url, this.virtualPrinterDataToUpload, altData ).subscribe( response => {
      const r = response.body;

      if ( !r.bOK ) {
        altData.msgObject.success.active = false;

        if ( !altData.msgObject.errors.some(el => {
          return el.error === 'http_error';
        }) ) {
          altData.msgObject.errors.push( {
            error: 'http_error',
            active: true,
            message: r.sMsgError
          } );
        } else {
          altData.msgObject.errors.forEach( el => {
            if ( el.error === 'http_error') {
              el.message = r.sMsgError;
            }
          });
        }

      } else {
        if ( altData.msgObject.errors.some( el => {
          return el.error === 'http_error';
        } )) {
          altData.msgObject = altData.msgObject.errors.filter( el => {
            return el.error !== 'http_error';
          });
        }

        this.commonService.addToast({
          life: 5000,
          severity: 'success',
          summary: this.success_title,
          detail: this.success_body + ' ( Type: ' + altData.uploadType + '. Release: ' + data.release + ' )'
        });
      }
      that.updateDownloadableList.emit( true );
      that.initData( );
    });
  }
}
